import React from 'react'
import styled from 'styled-components';

const PriceBoxStyle = styled.div`
  .pricetxt {
    color: #999999;
    font-size: 18px;
  }
  .pricenum {
    color: #000;
    margin-top: 10px;
    font-weight: 500;
    >span:first-child {
      font-size: 44px;
      margin-right: 10px;
    }
    >span:last-child {
      font-size: 26px;
    }
  }
`;

const PriceBoxSmStyle = styled.div`
  .pricetxt {
    color: #999999;
    font-size: 14px;
  }
  .pricenum {
    color: #000;
    margin-top: 0;
    font-weight: 500;
    >span:first-child {
      font-size: 36px;
      margin-right: 10px;
    }
    >span:last-child {
      font-size: 22px;
    }
  }
`;

export default function PriceBox(props) {
  const ret = <>
    <div className="pricetxt">Fixed price</div>
    <div className="pricenum">
      <span>{props.children}</span>
      <span>BNB</span>
    </div>
    </>;
  if (props.size === 'sm') {
    return (<PriceBoxSmStyle>{ret}</PriceBoxSmStyle>);
  } else {
    return (<PriceBoxStyle>{ret}</PriceBoxStyle>);
  }
}
